import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';
import {
  reportFieldsDefinitionSelector,
  reportsNamesSelector,
  selectedScenarioToCompareSelector,
} from '../../shared/store/selectors';

export const isLoadingScenariosSelector = ({ scenarios }) =>
  scenarios.members.isLoadingScenarios;

export const isLoadingScenariosMembersDataSelector = ({ scenarios }) =>
  scenarios.members.isLoadingScenarioMembersData;

export const countriesByCountryCodeSelector = ({ scenarios }) =>
  keyBy(scenarios.members.countries.map(country => ({
    ...country,
    name: country.countryDescription.split('-')[1].trim(),
  })), 'countryCode');

const isObject = arg => typeof arg === 'object';

const isComparingModeSelector = createSelector(
  selectedScenarioToCompareSelector,
  scenarioToCompare => Boolean(scenarioToCompare)
);

const scenarioMembersDataSelector = ({ scenarios }) =>
  scenarios.members.scenarioMembersData;

export const scenarioMembersDataForMemberListSelector = createSelector(
  scenarioMembersDataSelector,
  countriesByCountryCodeSelector,
  reportFieldsDefinitionSelector,
  reportsNamesSelector,
  isComparingModeSelector,
  (reportsData, countries, reportFields, reportNames, isComparingMode) =>
    reportNames.flatMap(reportName =>
      get(reportsData, reportName, []).map(rowData => {
        const [countryCode] = rowData.COUNTRY_TAX_TYPE.split('-');

        return reportFields.reduce((row, { unifiedName, ...rest }) => {
          const from = isObject(rest.from)
            ? rest.from[reportName]
            : rest.from;

          if (!from || !unifiedName) {
            return row;
          }

          if (isComparingMode) {
            row[`BASE_${unifiedName}`] = rowData[`BASE_${from}`];
            row[`VARIANCE_${unifiedName}`] = rowData[`VARIANCE_${from}`];
            row[`COMPARE_${unifiedName}`] = rowData[`COMPARE_${from}`];
          }

          row[unifiedName] = rowData[from];

          return row;
        }, {
          COUNTRY_NAME: countries[countryCode] && countries[countryCode].name,
          COMPANY_CODE: rowData.COMPANY_CODE,
          COUNTRY_TAX_TYPE: rowData.COUNTRY_TAX_TYPE,
          CC_DESCRIPTION: rowData.CC_DESCRIPTION,
        });
      })
    ).sort((a, b) => {
      const value = a.COMPANY_CODE.localeCompare(b.COMPANY_CODE);
      if (value) {
        return value;
      }
      return a.COUNTRY_TAX_TYPE.localeCompare(b.COUNTRY_TAX_TYPE);
    })
);

